import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   Blockquote,
   History,
   CustomMention,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
} from '../extensions';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { MenuSeparator } from '../components/MenuSeparator';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   BlockquoteButton,
   UndoButton,
   RedoButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const CommentsExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   Blockquote,
   History,
   CustomMention,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
];

export const CommentsMenuBar = (props: any) => {
   return (
      <TiptapMenubar>
         <BoldButton />
         <ItalicButton />
         <CodeButton />
         <LinkButton />
         <BlockquoteButton />
         <MenuSeparator />
         <UndoButton />
         <RedoButton />
      </TiptapMenubar>
   );
};
